export default {
  loading: "កំពុងផ្ទុក...",
  open: "បើក",
  close: "បិទ",
  stake: "ចំនួនភ្នាល់",
  crdr: "ឈ្នះ/ចាញ់",
  item: "ធាតុ",
  valid: "មានសុពលភាព",
  home_preferences: "ចំណង់ចំណូលចិត្តគេហទំព័រ",
  quick_links: "តំណភ្ជាប់រហ័ស",
  language: "ភាសា",
  home_page: "ទំព័រដើម",
  favorites: "ចំណង់ចំណូលចិត្ត",
  note: "ចំណាំ",
  my_bets: "ការភ្នាល់របស់ខ្ញុំ",
  my_account: "គណនី",
  contact_us: "ទាក់ទងមកយើង",
  report: "របាយការណ៍",
  help_support: "ជំនួយ & គាំទ្រ",
  currency: "រូបិយប័ណ្ណ",
  others: "ផ្សេងទៀត",
  welcome: "សូមស្វាគមន៍",
  account_id: "លេខសម្គាល់គណនី",
  password: "លេខសម្ងាត់",
  account: "គណនី",
  all_sports: "កីឡាទាំងអស់",
  my_sports: "កីឡារបស់ខ្ញុំ",
  action: "សកម្មភាព",
  accept_better_odds: "យល់ព្រមអត្រាឆ្នៃប្រសើរ",
  accept_any_odds: "យល់ព្រមអត្រាណាមួយ",
  auto_refresh_odds: "ធ្វើបច្ចុប្បន្នភាពអត្រាដោយស្វ័យប្រវត្តិ",
  auto_refresh: "ធ្វើបច្ចុប្បន្នភាពដោយស្វ័យប្រវត្តិ",
  auto_refreshing: "កំពុងធ្វើបច្ចុប្បន្នភាពដោយស្វ័យប្រវត្តិ...",
  all_markets: "ទីផ្សារទាំងអស់",
  available_balance: "សមតុល្យដែលមាន",
  athletics: "កីឡាអត្តលីត",
  american_football: "បាល់ទាត់អាមេរិក",
  aussie_rules_football: "បាល់ទាត់របៀបអូស្ត្រាលី",
  gmail: "អ៊ីមែល Gmail",
  contact_number: "លេខទំនាក់ទំនង",
  away: "ក្រៅផ្ទះ",
  all: "ទាំងអស់",
  accepted: "បានទទួល",
  add: "បន្ថែម",
  add_homescreen: "បន្ថែមទៅអេក្រង់ដើម",
  abandoned: "បានបោះបង់",


  bet_slip: "សន្លឹកភ្នាល់",
  bet_credit: "ឥណទានភ្នាល់",
  bet_list: "បញ្ជីភ្នាល់",
  betting: "ការភ្នាល់",
  balance: "សមតុល្យ",

  betting_statement: "សេចក្ដីថ្លែងការភ្នាល់",
  betting_rules: "ច្បាប់ការភ្នាល់",
  bet_types: "ប្រភេទភ្នាល់",
  bs: "ជ.ស.",
  bet_summary: "សង្ខេបការភ្នាល់",
  bets: "ការភ្នាល់",
  basketball: "បាល់បោះ",
  baseball: "បេស្បាល់",
  badminton: "វាយសី",
  bandy: "បាន់ឌី",
  boxing: "ប្រដាល់",
  beach_soccer: "បាល់ទាត់ឆ្នេរ",
  back: "ថយក្រោយ",

  casino: "កាស៊ីណូ",
  cash_balance: "សមតុល្យសាច់ប្រាក់",
  change_account_password: "ផ្លាស់ប្តូរលេខសម្ងាត់គណនី",
  current_password: "លេខសម្ងាត់បច្ចុប្បន្ន",
  confirm_new_password: "បញ្ជាក់លេខសម្ងាត់ថ្មី",
  customize_sports_order: "ប្តូរចំណាត់ថ្នាក់ទ្រង់ទ្រាយកីឡា",
  choice: "ជម្រើស",
  credit: "ឥណទាន",
  commission: "កម្រៃជើងសារ",
  customize: "ប្តូរតាមបំណង",
  cancel: "បោះបង់",
  confirmation: "ការបញ្ជាក់",
  continue_bet: "បន្តការភ្នាល់",
  customer_service: "បន្ទាយបម្រើអតិថិជន",
  cricket: "គ្រីខិត",
  cycling: "ជិះកង់",
  copa_america: "កូបាអាមេរិកា",
  combinations: "បន្សំនានា",
  create_room: "បង្កើតបន្ទប់ឯកជន",


  darts: "ព្រួញបាញ់",
  debit: "បញ្ចុះប្រាក់",
  display_language: "ភាសាដែលបង្ហាញ",
  default_event_sorting: "ការរៀបចំព្រឹត្តិការណ៍លំនាំដើម",
  default_stake: "ចំនួនភ្នាល់លំនាំដើម",
  date: "កាលបរិច្ឆេទ",
  draw: "ស្មើ",
  draw_cancel: "ស្មើ",
  dec: "ទសភាគ",
  double_line: "បន្ទាត់ទ្វេ",
  disable: "បិទ",
  dec_odds: "DEC | អត្រាទសភាគ",
  id_odds: "IND | អត្រាឥណ្ឌូ",
  double_chance: "ឱកាសទ្វេ",
  details: "ព័ត៌មានលម្អិត",

  enable: "បើក",
  event_sorting: "ការរៀបចំព្រឹត្តិការណ៍",
  e_sports: "អេ-ស្ប័រត",
  esports2: "អេ-ស្ប័រត 2",
  edit: "កែប្រែ",
  early: "មុនពេល",
  event: "ព្រឹត្តិការណ៍",
  even: "គូ",
  email: "អ៊ីមែល",
  esports: "អេ-ស្ប័រត",
  entry_fee: "ថ្លៃចូលរួម",
  exclusive: "ពិសេស",
  event_worldcup: "Worldcup",
  event_euro: "EURO 2024",
  event_copa: "COPA 2024",
  event_olympic: "Olympic 2024",
  event_club_worldcup: "CLUB WORLD CUP",
  event_women_euro: "EURO ស្ត្រី",
  event_nation_league: "NATION LEAGUE",
  event_fifa_club: "FIFA CLUB",


  es_101: "ផែនទី 1",
  es_102: "ផែនទី 2",
  es_103: "ផែនទី 3",
  es_104: "ផែនទី 4",
  es_105: "ផែនទី 5",
  es_106: "ផែនទី 6",
  es_107: "ផែនទី 7",
  es_108: "ផែនទី 8",
  es_109: "ផែនទី 9",
  es_110: "ផែនទី 10",

  fd_101: "រង្វាន់ទី 1",
  fd_102: "រង្វាន់ទី 2",
  fd_103: "រង្វាន់ទី 3",

  first_goal: "គ្រាប់បាល់ដំបូង",
  first_half: "ខែ្មះដំបូង",
  final: "វគ្គចុងក្រោយ",
  full_time: "ពេញម៉ោង",
  from: "ពី",
  field_hockey: "ហុកគីលើទីលានស្មើ",
  futsal: "បាល់ទាត់ក្នុងផ្ទះ",
  fd: "4D ពិសេស",
  fishing: "នេសាទ",
  fold: "ចម្រុះ",

  gaelic_football: "បាល់ទាត់ហ្គេលិច",
  golf: "កីឡាវាយកូនហ្គោល៍",
  games: "ហ្គេម",
  given_credit: "ឥណទានដែលបានផ្ដល់",
  group: "ក្រុម",
  goal: "គ្រាប់បាល់",
  general: "ទូទៅ",
  general_betting_rules: "ច្បាប់ភ្នាល់ទូទៅ",
  general_rules_market: "ច្បាប់ទូទៅ: ផ្សារ (ប្រភេទភ្នាល់)",

  half_time: "ពាក់កណ្តាលម៉ោង",
  hide_header: "លាក់បឋមកថា",
  hk: "HK",
  hk_odds: "HK | អត្រា ហុងកុង",
  hdp: "HDP",
  home: "ផ្ទះ",
  hotline: "លេខទំនាក់ទំនងបន្ទាន់",
  handball: "បាល់ដៃ",
  hurling: "ហឺលលីង",
  hour: "ម៉ោង",
  highlight: "ព្រឹត្តិការណ៍ពិសេស",


  id: "អត្តសញ្ញាណ",
  ice_hockey: "ហុកគីទឹកកក",

  joined: "បានចូលរួមតែប៉ុណ្ណោះ",
  join_now: "ចូលរួមឥឡូវនេះ",
  jackpot: "ជេកផត",

  keno: "គេនូ",
  kickoff: "ចាប់ផ្តើមការប្រកួត",
  kabbadi: "កាបាឌី",
  kof: "កីឡា King of Fighters",
  ko: "លត់ដោយ",

  lose: "ចាញ់",
  lose_half: "ចាញ់កន្លះ",
  lottery: "ឆ្នោត",
  login: "ចូល",
  logout: "ចេញ",
  last_login: "ចូលចុងក្រោយ",
  last_transaction: "ប្រតិបត្តិការចុងក្រោយ",
  live_streaming: "ផ្សាយបន្តផ្ទាល់",
  live_match: "ការប្រកួតផ្ទាល់",
  live_chat: "ជជែកផ្ទាល់",
  live: "ផ្ទាល់",
  virtual: "និម្មិត",
  live_tv: "ទូរទស្សន៍ផ្ទាល់",
  livecasino: "កាស៊ីណូផ្ទាល់",
  loss: "ការបាត់បង់",
  lost: "បានចាញ់",
  last_bet: "ភ្នាល់ចុងក្រោយ",
  last_goal: "គ្រាប់ចុងក្រោយ",
  leave_room: "ចាកចេញពីបន្ទប់",
  last_betting_time: "ពេលភ្នាល់ចុងក្រោយ",
  lose_all: "ចាញ់ទាំងអស់",

  mobile: "ទូរស័ព្ទចល័ត",
  message: "សារ",
  my_bet: "ការភ្នាល់របស់ខ្ញុំ",
  my_favorites: "ចំណង់ចំណូលចិត្តរបស់ខ្ញុំ",
  market_type: "ប្រភេទទីផ្សារ",
  match: "ការប្រកួត",
  message_history: "ប្រវត្តិសារណា",
  my: "MY",
  market: "ទីផ្សារ",
  main_markets: "ទីផ្សារសំខាន់ៗ",
  my_odds: "MY | អត្រាមាឡេ",
  mmo_parlay: "ភ្នាល់រួមမြန်မာ",
  mmo_odds: "អត្រាជម្រើសမြန်မာ",
  min: "អប្បបរមា",
  max: "អតិបរមា",
  max_payout: "ការទូទាត់អតិបរមា",
  main: "សំខាន់",
  corners: "ជ្រុង/កាតបោក",
  specials: "ពិសេស",
  mix_parlay: "ភ្នាល់រួមលាយ",
  mma: "សិល្បៈប្រយុទ្ធផ្សំ (MMA)",
  motorsports: "កីឡាម៉ូតូ",
  muay_thai: "មวยថៃ",
  map1: "ផែនទី 1",
  map2: "ផែនទី 2",
  map3: "ផែនទី 3",
  map4: "ផែនទី 4",
  map5: "ផែនទី 5",
  map6: "ផែនទី 6",
  map7: "ផែនទី 7",
  map8: "ផែនទី 8",
  map9: "ផែនទី 9",
  matches: "ការប្រកួត",
  mini_arcade: "ហ្គេមតូច",
  match_started: "-",


  no_goal: "មិនមានគ្រាប់បាល់",
  normal_announcements: "សេចក្ដីប្រកាសធម្មតា",
  nickname: "ឈ្មោះហៅក្រៅ",
  new_password: "លេខសម្ងាត់ថ្មី",
  new: "ថ្មី",
  "no/": "ល.រ.",
  normal_sorting: "តម្រៀបធម្មតា",
  netball: "បាល់បាញ់តំណាង",
  newsinfo: "ព័ត៌មាន & ព័ត៌មានអំពី",
  next: "បន្ទាប់",

  olympic: "អូឡាំពិក",
  other_markets: "ទីផ្សារផ្សេងទៀត",
  outstanding: "នៅសល់",
  odds_type: "ប្រភេទអត្រា",
  odds: "អត្រា",
  opening_balance: "សមតុល្យចាប់ផ្តើម",
  outright: "ជើងឯកជាប់",
  oe: "គូ/សេស",
  on: "បើក",
  off: "បិទ",
  outstanding_bet: "ការភ្នាល់នៅសល់",
  over: "លើ",
  odd: "សេស",
  official_link: "តំណភ្ជាប់ផ្លូវការ",
  owner: "ម្ចាស់",

  password_expiry: "ថ្ងៃផុតកំណត់លេខសម្ងាត់",
  parlay: "ភ្នាល់រួម",
  parlay_early: "ភ្នាល់រួមដំបូង",
  page_display: "ការបង្ហាញទំព័រ",
  page_type: "ប្រភេទទំព័រ",
  page_size: "ទំហំទំព័រ",
  personal_message: "សារផ្ទាល់ខ្លួន",
  process_bet: "ដាក់ភ្នាល់",
  payout: "ការទូទាត់",
  pending: "រងចាំ",
  personal: "ផ្ទាល់ខ្លួន",
  play_now: "លេងឥឡូវនេះ",
  parlay_generator: "កម្មវិធីបង្កើតភ្នាល់រួម",
  private: "ឯកជន",
  pool: "ទូទាត់ $",
  players: "អ្នកលេង",
  points: "ពិន្ទុ",
  prize: "រង្វាន់",
  play_to_earn: "លេងដើម្បីរកចំណូល",

  quick_bet: "ភ្នាល់រហ័ស",
  qq: "QQ",


  room: "បន្ទប់",
  result: "លទ្ធផល",
  restore: "ស្ដារឡើងវិញ",
  remark: "កំណត់សម្គាល់",
  ref_no: "លេខយោង",
  remove_from_parlay: "យកចេញពីភ្នាល់រួម",
  running: "កំពុងដំណើរការ",
  reject: "បដិសេធ",
  rejected: "បានបដិសេធ",
  rugby: "រុកប៊ី",
  roundof16: "វគ្គ១៦ក្រុម",
  quater_finals: "វគ្គ៨ក្រុមចុងក្រោយ",
  semi_finals: "វគ្គពាក់កណ្ដាលផ្ដាច់ព្រ័ត្រ",
  room_id: "លេខសម្គាល់បន្ទប់",
  refund: "សងប្រាក់វិញ",

  skype: "Skype",
  sports: "កីឡា",
  show_balance: "បង្ហាញសមតុល្យ",
  statement: "របាយការណ៍",
  settings: "ការកំណត់",
  search_team: "ស្វែងរកក្រុម",
  show_header: "បង្ហាញបឋមកថា",
  submit: "ដាក់ស្នើ",
  set_nickname: "កំណត់ឈ្មោះហៅក្រៅ",
  single: "តែមួយ",
  save: "រក្សាទុក",
  show_score_map: "បង្ហាញផែនទីពិន្ទុ",
  status: "ស្ថានភាព",
  sort: "តម្រៀប",
  sportsbook: "បញ្ជីកីឡា",
  sum: "សរុប",
  special_announcements: "សេចក្ដីប្រកាសពិសេស",
  subtotal: "សរុបរង",
  single_line: "បន្ទាត់តែមួយ",
  sort_by_time: "តម្រៀបតាមពេល",
  slots: "ម៉ាស៊ីនបោកស្លុត",
  select_leagues: "ជ្រើសរើសលីគ",
  special: "ពិសេស",
  scroll_bottom: "ចុចដើម្បីរមៀលចុះទៅតំបន់ភ្នាល់",
  swipe_to_search: "ស្ទូចដៃដើម្បីស្វែងរក",
  soccer: "បាល់ទាត់",
  squash: "ស្ក្វាស",
  sepak_takraw: "សីផាកតាក្រោ",
  snooker: "ស្នុកកឺរ/ពូល",
  suite_sa: "SA Gaming",
  suite_gp: "Game Play",
  suite_evo: "Evolution",
  suite_ct855: "CT855",
  suite_bg: "ម៉ាកាវស៊ុយ",
  suite_pg: "Pretty Gaming",
  suite_yb: "Yeebet",
  "suite_pp-c": "Pragmatic",
  suite_ai: "AI Casino",
  suite_sexy: "Sexy Casino",
  suite_onlive: "Onlive Casino",
  suite_mt: "MT Casino",
  suite_foxy: "Foxy Casino",
  sfv_101: "ជុំទី 1",
  sfv_102: "ជុំទី 2",
  sfv_103: "ជុំទី 3",
  sfv_104: "ជុំទី 4",
  sfv_105: "ជុំទី 5",

  settlement: "ដោះស្រាយ",
  settled_amount: "ចំនួនដែលបានដោះស្រាយ",
  sfv: "Street Fighter V",
  search: "ស្វែងរក",
  sysparlay: "ភ្នាល់ប្រព័ន្ធរួម",
  stake_per_bet: "ចំនួនភ្នាល់ក្នុងមួយ",
  score: "ពិន្ទុ",
  winner: "អ្នកឈ្នះ",
  slot_live22: "Live22",
  slot_pgs: "PGSoft",
  slot_ppg: "Pragmatic Play",
  slot_jkr: "Joker",
  slot_spp: "Simple Play",
  slot_jili: "Jili",
  slot_uusl: "UUSlot",
  slot_next: "Nextspin",
  slot_dbhash: "DB Hash",
  slot_wow: "WOW Gaming",
  slot_wf: "WF Gaming",
  slot_epw: "Epicwin",
  slot_epwmg: "Epicwin Mini",
  selected: "បានជ្រើសរើស",
  select_matches: "ជ្រើសរើសការប្រកួត",
  slots_rules: "ច្បាប់ហ្គេមម៉ាស៊ីនបោកស្លុត",

  turnover: "ចំណូលចំណាយ",
  today: "ថ្ងៃនេះ",
  time: "ពេលវេលា",
  team: "ក្រុម",
  to: "ទៅកាន់",
  trans_time: "ពេលវេលាប្រតិបត្តិការ",
  total: "សរុប",
  total_goal: "គ្រាប់បាល់សរុប",
  treble: "ភ្នាល់បីគូ",
  total_bets: "ចំនួនភ្នាល់សរុប",
  tnc: "លក្ខខណ្ឌទូទៅ",
  tennis: "កីឡាទីនីស",
  table_tennis: "ប៉េងប៉ុង",
  telegram: "Telegram",
  tournament: "ការប្រកួត",
  total_points: "ពិន្ទុសរុប",
  tournament_refund: "សងប្រាក់វិញការប្រកួត",

  under: "ក្រោម",
  void: "មោឃៈ",
  volleyball: "បាល់ឆ្នេរ",
  void_list: "បញ្ជីដែលត្រូវមោឃៈ",
  view_odds: "មើលអត្រាក្នុងការភ្នាល់",
  video: "វីដេអូ",

  won_all: "ឈ្នះទាំងអស់",
  won_half: "ឈ្នះពាក់កណ្តាល",
  win_half: "ឈ្នះពាក់កណ្តាល",
  win: "ឈ្នះ",
  won: "បានឈ្នះ",
  waiting: "កំពុងរង់ចាំ",
  wechat: "WeChat",
  whatsapp: "WhatsApp",
  winter_sports: "កីឡារដូវរងា",
  water_polo: "បាល់ទឹក",
  winner_rank: "ចំណាត់ថ្នាក់អ្នកឈ្នះ",

  yes: "បាទ/ចាស",
  no: "ទេ",


  yesterday: "ម្សិលមិញ",
  monday: "ថ្ងៃចន្ទ",
  tuesday: "ថ្ងៃអង្គារ",
  wednesday: "ថ្ងៃពុធ",
  thursday: "ថ្ងៃព្រហស្បតិ៍",
  friday: "ថ្ងៃសុក្រ",
  saturday: "ថ្ងៃសៅរ៍",
  sunday: "ថ្ងៃអាទិត្យ",

  all_league: "ទាំងអស់",
  match_completed: "បានបញ្ចប់",
  match_pending: "រងចាំលទ្ធផល",
  match_cancelled: "សងប្រាក់វិញ",
  match_cancelled_1h: "សងប្រាក់វិញ 1H",
  match_cancelled_2h: "សងប្រាក់វិញ 2H",
  match_suspended: "បានផ្អាក",
  match_suspended_1h: "ផ្អាក 1H",
  match_suspended_2h: "ផ្អាក 2H",

  check_all: "ពិនិត្យទាំងអស់",
  selected_only: "តែអ្វីដែលបានជ្រើស",
  filtered: "បានត្រង",
  turn_on: "បើក",
  turn_off: "បិទ",

  more_bet_types: "ប្រភេទភ្នាល់បន្ថែម",
  switch_to_desktop: "ប្ដូរទៅកាន់កម្មវិធីក្នុងកុំព្យូទ័រ",

  events: "ព្រឹត្តិការណ៍",
  brackets: "ចំណាត់ថ្នាក់",
  standing: "ចំណាត់ថ្នាក់",

  big_small: "ធំ/តូច",
  odd_even: "សេស/គូ",

  first_digit: "ខ្ទង់ទី១",
  second_digit: "ខ្ទង់ទី២",
  third_digit: "ខ្ទង់ទី៣",
  forth_digit: "ខ្ទង់ទី៤",
  total_4d: "សរុប 4D",
  total_3d: "សរុប 3 ខ្ទង់ចុងក្រោយ",
  total_1st2d: "សរុប 2 ខ្ទង់ដំបូង",
  total_last2d: "សរុប 2 ខ្ទង់ចុងក្រោយ",
  total_winlose: "សរុប ឈ្នះ/ចាញ់",
  tomorrow: "ថ្ងៃស្អែក",

  news: "ព័ត៌មាន",
  more: "បន្ថែម",
  current_live: "កំពុងផ្សាយបន្តផ្ទាល់",
  upcoming: "កំពុងមកដល់",
  prematch: "មុនការប្រកួត",
  desktop_view: "ទិដ្ឋភាពលើកុំព្យូទ័រ",
  back_to_lobby: "ត្រឡប់ទៅផ្ទះ",
  coming_soon: "មកដល់បន្ទាប់",
  no_record: "មិនមានកំណត់ត្រា",
  bet_time: "ពេលវេលាភ្នាល់",
  seven_days: "៧ ថ្ងៃចុងក្រោយ",
  fourteen_days: "១៤ ថ្ងៃចុងក្រោយ",
  winlose: "ឈ្នះ/ចាញ់",
  all_transaction: "ប្រតិបត្តិការទាំងអស់",
  transfer: "ផ្ទេរ",
  hide: "លាក់",
  more_details: "ព័ត៌មានបន្ថែម",
  bet: "ភ្នាល់",
  comm: "កម្រៃជើងសារ",
  settled: "បានដោះស្រាយ",
  total_stake: "ចំនួនភ្នាល់សរុប",
  deselect_all: "លែងជ្រើសទាំងអស់",
  select_all: "ជ្រើសទាំងអស់",
  done: "រួចរាល់",
  early_all: "មុនប្រកួត (ទាំងអស់)",
  more_markets: "ទីផ្សារបន្ថែម",
  folds_2: "២ ភ្នាល់រួម",
  folds_3: "៣ ភ្នាល់រួម",
  folds_4: "៤ ភ្នាល់រួម",
  folds_5: "៥ ភ្នាល់រួម",
  folds_6: "៦ ភ្_",


  worldcup: "ពិភពលោក ២០២៦",
  time_remaining: "ពេលវេលាដែលនៅសល់",

  slot_championstar: "Champion Star",
  slot_fifafiesta: "Fifa Fiesta",
  slot_penaltymania: "Penalty Mania",
  minigame_dragon: "Dragon's Treasure",
  minigame_illuvium: "Illuvium Master",
  minigame_mobo: "Mobox Olympia",

  egames: "V-Game",
  feedback: "មតិប្រើប្រាស់របស់អ្នក",
  ranking: "ចំណាត់ថ្នាក់",
  total_winning: "ចំនួនឈ្នះសរុប",
  first_prize: "រង្វាន់ទី ១",
  second_prize: "រង្វាន់ទី ២",
  third_prize: "រង្វាន់ទី ៣",
  place: "ចំណាត់ថ្នាក់",
  current_point: "ពិន្ទុបច្ចុប្បន្ន",
  free_room: "បន្ទប់ឥតគិតថ្លៃ",
  last_join_time: "ពេលចូលចុងក្រោយ",
  archery: "ធ្វើវាយធ្នូ",
  ufc: "UFC",
  winter_olympic: "奥林匹克រដូវរងា",
  no1: "អ្នកឈ្នះលេខ ១",
  adjustment: "កែសម្រួល",
  poker: "ប៉ុកខឺ",
  poker_db: "DB Poker",
  yellow: "លឿង",
  blue: "ខៀវ",
  first_ball: "បាល់ទី១",
  best_5_balls: "បាល់ល្អបំផុត ៥ គ្រាប់",
  binary_allin: "Binary",
  live_now: "កំពុងផ្សាយបន្តផ្ទាល់",
  upcoming_matches: "កំពុងមកដល់",
  others_game: "ការប្រកួតបន្ថែម",
  virtual_sports: "ការប្រកួតបន្ថែមទូទាត់សម្រាប់ការប្រកួតបន្ថែម",
  more_hdp_markets: "ទីផ្សារ HDP បន្ថែម",
  statistics: "ស្ថិតិ",
  asia_hdp: "Asia HDP",
  mmo: "MMO",
  available: "ស្ថិតិ",
  bomberman: "Super Bomberman",
  mario: "Mario Party",
  cock_fight: "Cock Fight",
  marble_rafting: "Marble Rafting",
  naruto: "Naruto",
  dragon_ball: "Dragon Ball",
  marble_survival: "Marble Survival",
  marble_clash: "Marble Clash",
  marble_run: "Marble Run",
  tekken8: "Tekken 8",
  speedway: "Speedway",
  greyhound: "Greyhound",
  mortal_kombat: "Mortal Kombat",
  kof: "King of Figthers",
  ufc3: "UFC 3",
  street_fighter: "Street Fighter",
  round1: "ជុំទី 1",
  round2: "ជុំទី 2",
  round3: "ជុំទី 3",

  round1_1stBoom: "BOOM ដំបូង ជុំទី១",
  round2_1stBoom: "BOOM ដំបូង ជុំទី២",
  round3_1stBoom: "BOOM ដំបូង ជុំទី៣",

  classic_view: "ទិដ្ឋភាពការក្រាហ្វិក",
  modern_view: "ទិដ្ឋភាពការក្រាហ្វិកថ្មី",
  time_machine_tm: " (T.Machine)",
  back: "ត្រឡប់",
};
